export default __webpack_public_path__ + "static/media/add-product.43f9f9ce.svg";